<template>
  <el-dialog
    v-model="visible"
    append-to-body
    class="ai-session-mobile-menu"
    modal-class="ai-session-mobile-overlay"
    :show-close="false"
    :style="menuStyle"
    title="任务操作"
  >
    <div class="ai-session-mobile-menu__preview">
      <i
        v-if="session?.sourceType === 'schedule'"
        aria-hidden="true"
        class="icon-timer-line t-iconfont"
      ></i>
      <span>{{ session?.title || '未知标题会话' }}</span>
    </div>
    <div aria-label="更多操作" class="ai-session-mobile-menu__actions" role="menu">
      <button role="menuitem" type="button" @click="handleCommand('top')">
        <span>{{ isTop ? '取消置顶' : '置顶' }}</span>
        <i
          aria-hidden="true"
          class="t-iconfont"
          :class="isTop ? 'icon-unpin-line' : 'icon-pushpin-line'"
        ></i>
      </button>
      <button role="menuitem" type="button" @click="handleCommand('rename')">
        <span>重命名</span><i aria-hidden="true" class="icon-edit-line t-iconfont"></i>
      </button>
      <button
        class="ai-session-mobile-menu__delete"
        role="menuitem"
        type="button"
        @click="handleCommand('delete')"
      >
        <span>删除</span><i aria-hidden="true" class="icon-delete-bin-line t-iconfont"></i>
      </button>
    </div>
  </el-dialog>
</template>

<script setup>
import { computed } from 'vue'

const props = defineProps({
  modelValue: Boolean,
  session: { type: Object, default: null },
  anchorRect: { type: Object, default: null },
  isTop: { type: Number, default: 0 }
})
const emits = defineEmits(['update:modelValue', 'command'])
const visible = computed({
  get: () => props.modelValue,
  set: (value) => emits('update:modelValue', value)
})
const menuStyle = computed(() => {
  const rect = props.anchorRect
  if (!rect) return {}
  // 为高亮任务和三项操作预留空间，靠近底部时整体向上避让。
  const width = Math.min(rect.width, window.innerWidth - 24)
  return {
    left: `${Math.max(12, Math.min(rect.left, window.innerWidth - width - 12))}px`,
    top: `${Math.max(16, Math.min(rect.top, window.innerHeight - 224))}px`,
    width: `${width}px`
  }
})
const handleCommand = (command) => {
  visible.value = false
  if (props.session) emits('command', command, props.session)
}
</script>

<style lang="scss" scoped>
:global(.ai-session-mobile-overlay) {
  background: rgba(0, 0, 0, 0.2);
  -webkit-backdrop-filter: blur(5px);
  backdrop-filter: blur(5px);
}
:global(.ai-session-mobile-menu.el-dialog) {
  position: fixed;
  margin: 0;
  padding: 0;
  background: transparent;
  box-shadow: none;
  border-radius: 0;
  font-family: 'PingFang SC', sans-serif;
  color: #242832;
}
:global(.ai-session-mobile-menu .el-dialog__header) {
  display: none;
}
:global(.ai-session-mobile-menu .el-dialog__body) {
  padding: 0;
}
.ai-session-mobile-menu__preview {
  user-select: none;
  display: flex;
  align-items: center;
  min-height: 44px;
  box-sizing: border-box;
  padding: 10px 12px;
  border-radius: 12px;
  background: #ffffff;
  color: #242832;
  font-size: 14px;
  line-height: 24px;
  box-shadow: 0 4px 16px rgba(15, 23, 42, 0.12);
  span {
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
  .t-iconfont {
    flex-shrink: 0;
    margin-right: 8px;
    font-size: 16px;
  }
}
.ai-session-mobile-menu__actions {
  width: 280px;
  max-width: 100%;
  margin-top: 12px;
  overflow: hidden;
  border-radius: 12px;
  background: #ffffff;
  box-shadow: 0 6px 16px rgba(15, 23, 42, 0.12);
  button {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    min-height: 48px;
    padding: 12px 16px;
    border: 0;
    background: #ffffff;
    color: #242832;
    font: inherit;
    font-size: 14px;
    line-height: 24px;
    text-align: left;
    cursor: pointer;
    &:active {
      background: #f2f3f5;
    }
    &:focus-visible {
      outline: 2px solid #7a52f4;
      outline-offset: -2px;
    }
  }
  button + button {
    border-top: 1px solid #eef1f8;
  }
  .t-iconfont {
    margin-left: 12px;
    font-size: 20px;
  }
  .ai-session-mobile-menu__delete {
    color: #b42318;
  }
}
</style>
